import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  // Added by Amisha on 2026-06-12.
  // Reason: AppView now needs router snapshot context so Janus-only leave
  // confirmation can distinguish real route exits from safe internal transitions.
  canDeactivate: (
    currentRoute?: ActivatedRouteSnapshot,
    currentState?: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) => boolean | Promise<boolean> | Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  canDeactivate(
    component: ComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ) {
    if (component.canDeactivate) {
      // Added by Amisha on 2026-06-12.
      // Reason: forward route context to AppView so its Janus-specific
      // confirmation rules can evaluate the destination accurately.
      return component.canDeactivate(currentRoute, currentState, nextState);
    }
    return true;
  }
}
